import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text } from '../../common';
import { getThemeColor } from '../../../../utils/theme';

export const VerifiedSelect = styled.div`
  position: relative;
  max-width: 190px;
  width: 100%;
`;

export const VerifiedItem = styled.button`
  display:flex;
  align-items:center;
  padding: 6px 10px 6px;
  background: 0;
  border: 1px solid transparent;
  width: 100%;
  cursor: pointer;
  outline: none;
  border-radius: 2px;
  ${({active}) => active && `
      border: 1px solid #1d1d6c;
      background-color: #f6f9fc;
      ${VerifiedIconArrow} {
        transform: rotate(180deg);
      }
  `}
`;

export const VerifiedText = styled(Text)``;

export const VerifiedDrop = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 10px 0;
  background-color: ${getThemeColor(['greyLight'])};
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  z-index: 20;
`;

export const VerifiedDropItem = styled.button`
  display:flex;
  align-items:center;
  padding: 6px 10px 6px;
  z-index: 20;
  background: 0;
  border: 0;
  width: 100%;
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: ${getThemeColor(['violet'])};
    ${VerifiedText} {
      color: ${getThemeColor(['white'])};
    }
  }
`;

export const VerifiedIconCheckWrap = styled.div`
  border-radius: 50%;
  display:flex;
  align-items:center;
  justify-content:center;
  width: 18px;
  height: 18px;
  color: ${getThemeColor(['white'])};
  background-color: ${({ bgColor }) => getThemeColor([bgColor || 'greyVioletLight'])};
  margin-right: 12px;
`;

export const VerifiedIconCheck = styled(FontAwesomeIcon)`
   font-size: 10px;
`;

export const VerifiedIconArrow = styled(FontAwesomeIcon)`
  margin-left: auto;
  cursor: pointer;
  font-size: 20px;
  transition: all .3s ease-in-out;
`;

export const SelectCheck = styled(FontAwesomeIcon)`
  color: ${getThemeColor(['red'])};
  margin-left: auto;   
  font-size: 16px;
`;
